import React from 'react';

import { classNames } from '@/helpers/classNames';

import styles from './ModalSectionTitle.module.scss';

type ModalSectionTitleProps = {
	className?: string;
	sideComponent?: React.ReactElement;
	centered?: boolean;
};

export const ModalSectionTitle: React.FC<ModalSectionTitleProps> = ({
	className,
	sideComponent,
	centered,
	children,
}) => {
	const classes = classNames([styles['root'], centered && styles['centered'], className]);

	return (
		<div className={classes}>
			<div className={styles['title']}>{children}</div>
			{sideComponent && (
				<div className={styles['side-component']}>{sideComponent}</div>
			)}
		</div>
	);
};
